import jwtDecode from 'jwt-decode';
import { getCookieDomain } from '../utils';
import { getSigningProcessIdFromUrl, isProduction } from './hosts';
import * as Utils from '../utils';
export const setCookie = (name, value, expirationTime, path, domain, sameSite, secure) => {
    var _a;
    if (path === void 0) { path = '/'; }
    if (domain === void 0) { domain = getCookieDomain((_a = window['autentiConfig']) === null || _a === void 0 ? void 0 : _a.env); }
    if (sameSite === void 0) { sameSite = 'strict'; }
    if (secure === void 0) { secure = 'secure'; }
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${new Date(expirationTime).toUTCString()}; path=${path}; domain=${domain}; ${secure}; SameSite=${sameSite}`;
};
export const getCookie = (name) => document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
}, '');
export const deleteCookie = (name) => {
    setCookie(name, '', Date.now() - 1000);
};
const getExpirationTime = (duration) => {
    const today = new Date();
    const ms = today.getTime();
    return ms + Number(duration);
};
export function setAuthCookies({ boxId, organizationId, expiresIn }, email) {
    const tokenExpirationTime = getExpirationTime(expiresIn);
    const cookieExpirationTime = tokenExpirationTime + 2 * 60 * 60 * 1000;
    setCookie('isLogged', '1', cookieExpirationTime);
    setCookie('email', email, cookieExpirationTime);
    setCookie('organizationId', organizationId, cookieExpirationTime);
    setCookie('isOrganization', organizationId !== null ? '1' : '0', cookieExpirationTime);
    setCookie('currentBoxId', boxId, cookieExpirationTime);
    setCookie('expirationTime', `${tokenExpirationTime}`, cookieExpirationTime);
}
export function setNotLoggedAuthCookies() {
    const tokenDuration = getCookie('documentlink-token-duration');
    const newTimeMS = getExpirationTime(tokenDuration);
    const processIdPath = `/${getSigningProcessIdFromUrl()}`;
    setCookie('tokenExpiration', `${newTimeMS}`, newTimeMS, processIdPath);
}
export const decodeCurrentBox = (token = getCookie('accessToken')) => {
    const currentBox = jwtDecode(token).bs.filter((item) => item.bc);
    if (currentBox.length !== 1) {
        throw new Error('currentBox not founded');
    }
    return currentBox;
};
export function hasLoginCookie() {
    return getCookie('isLogged') === '1';
}
export const logout = (redirectUrl, autoLogout, shouldRedirectAfterLogout = true) => {
    deleteCookie('isLogged');
    deleteCookie('email');
    deleteCookie('organizationId');
    deleteCookie('isOrganization');
    deleteCookie('currentBoxId');
    deleteCookie('expirationTime');
    deleteCookie('promoModalClosed');
    if (shouldRedirectAfterLogout) {
        redirectAfterLogout(redirectUrl, autoLogout);
    }
};
const redirectAfterLogout = (redirectUrl, autoLogout) => {
    const shouldRedirectAfterLogout = canRedirectToThis(redirectUrl);
    const basicUrl = `${Utils.getUrlTo('accounts')}/login?`;
    const redirectLink = shouldRedirectAfterLogout
        ? `${basicUrl}return=${redirectUrl}`
        : basicUrl;
    window.location.href = autoLogout
        ? `${redirectLink}&autoLogout`
        : redirectLink;
};
const canRedirectToThis = (url) => {
    if (!url) {
        return false;
    }
    const hostNameWithoutSubdomain = window.location.hostname
        .split('.')
        .slice(1)
        .join('.');
    const validHostName = isProduction()
        ? `.${hostNameWithoutSubdomain}`
        : hostNameWithoutSubdomain;
    const urlObj = new URL(decodeURIComponent(url));
    const urlHostname = urlObj.hostname;
    const autentiDomain = isProduction() ? '.autenti.com' : '.autenti.net';
    return (validHostName.includes(autentiDomain) && urlHostname.endsWith(validHostName));
};
export const getUnloggedExpirationTime = () => getCookie('tokenExpiration');
export const isOrganization = () => {
    const token = getCookie('isOrganization');
    if (token === '1')
        return true;
    return false;
};
export const isTokenExpired = (additionalSecondTime = 0) => {
    const expirationTime = Number(getCookie('expirationTime'));
    const currentTime = new Date().getTime();
    return expirationTime - currentTime - additionalSecondTime <= 0;
};
export const arePopupsTurnedOff = () => getCookie('arePopupsTurnedOff') === 'true';
